import { isExternalUrl } from '@/lib/utils/link-utils'
import type { PictureVariantProps } from '@/ui/media/picture/Picture.client'
import { z } from 'zod'

const pathSchema = z.string().refine((s) => isExternalUrl(s) || s.startsWith('/'), {
  message: 'image must be an absolute URL or a root-relative path',
})

export const cmsPictureSchema = z.object({
  path: pathSchema,
  pathDesktop: pathSchema.optional(),
  alt: z.string().min(1),
  mode: z.custom<PictureVariantProps['mode']>().optional(),
})

export type CMSPictureSchemaType = z.infer<typeof cmsPictureSchema>
